// Etsy research routes stay reachable in both shells (old links, bookmarks),
// but only the admin shell mounts the tabs: Alura's terms keep its data inside
// the PEXIFY team, so the seller shell shows a notice and calls nothing.
import type { ReactNode } from 'react'
import { EmptyState } from '../../components/ui/empty-state'
import { PageFrame } from '../../components/ui/page-frame'
import { PageHeader } from '../../components/ui/page-header'
import { RESEARCH_OPEN, useResearchStrings, type ResearchScope } from './research-route'

export function ResearchGate({ scope, children }: { scope: ResearchScope; children: ReactNode }) {
  const t = useResearchStrings()
  if (RESEARCH_OPEN[scope]) return <>{children}</>
  return (
    <PageFrame>
      <PageHeader title={t.title} />
      <EmptyState icon="fileSearch" title={t.teamOnly.title} description={t.teamOnly.body} />
    </PageFrame>
  )
}
